export default __webpack_public_path__ + "7c3730e92e1f0201324f2b5c94d82da3.png";